import { render, staticRenderFns } from "./create-project-dialog.vue?vue&type=template&id=264afd00&scoped=true"
import script from "./create-project-dialog.ts?vue&type=script&lang=js&external"
export * from "./create-project-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264afd00",
  null
  
)

export default component.exports